import React, { useEffect, useState } from 'react';
import { getShopProducts, createShopOrder } from '../services/api';
import { Button, Card, Row, Col, Modal, Form, Alert } from 'react-bootstrap';
import './ShopCard.css';
import { setupWeChatShare, isWeChat } from '../utils/wechat';

function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [quantity, setQuantity] = useState(1);
  const user = JSON.parse(localStorage.getItem('user')) || {};

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const res = await getShopProducts();
      setProducts(res.data);
    } catch (e) {
      setError('获取商品失败');
    } finally {
      setLoading(false);
    }
  };

  const handleBuy = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setShowModal(true);
    setSuccessMsg('');
    setError('');
  };

  const handleConfirmBuy = async () => {
    try {
      await createShopOrder(selectedProduct.id, quantity);
      setSuccessMsg('兑换成功！请在订单列表或积分明细中查看记录。');
      setShowModal(false);
      fetchProducts();
    } catch (e) {
      setError(e.response?.data?.message || '兑换失败');
      setShowModal(false); // 失败也关闭Modal
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>积分商城</h2>
        <div className="d-flex align-items-center">
          <a href="/shop/orders" className="btn btn-primary me-2">我的兑换订单</a>
          <a href="/user-points" className="btn btn-outline-secondary">积分兑换记录</a>
          {isWeChat() && (
            <div className="alert alert-info mb-0 ms-3 py-1 px-2" style={{fontSize: '1em', border: '1px solid #bee5eb', background: '#e8f7fa', borderRadius: 6}}>
              点击右上角“...”，选择“发送给朋友”或“分享到朋友圈”即可分享本页面
            </div>
          )}
        </div>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      {successMsg && <Alert variant="success">{successMsg}</Alert>}
      {products.length === 0 && !loading && (
        <div style={{background:'#ccf5ff', borderRadius:8, padding:'16px 0', textAlign:'center', marginTop:12, marginBottom:20, color:'#38b6c1', fontSize:'1.05em'}}>
          暂无可兑换商品
        </div>
      )}
      <Row xs={1} md={2} lg={3} className="g-4 mt-2">
        {products.map((product) => (
          <Col key={product.id}>
            <Card className="shop-card-fixed-height">
              <div className="shop-card-img">
                <img src={product.image || 'https://via.placeholder.com/300x200?text=No+Image'} alt={product.name} />
              </div>
              <Card.Body className="shop-card-body-fixed-height">
                <div className="shop-card-title" title={product.name}>{product.name}</div>
                <Card.Text>
                  <b>所需积分：</b>{product.points_required}<br/>
                  <div className="shop-card-desc-row">
                    <span className="shop-card-desc-label">商品介绍：</span>
                    <span className="shop-card-desc-content" title={product.description}>{product.description || '无'}</span>
                  </div>

                  {product.url && <a href={product.url} target="_blank" rel="noopener noreferrer">商品原始链接</a>}
                </Card.Text>
                <div className="mt-2">
                  <b>库存：</b>{product.stock}
                </div>
                {(user && (user.role === 'user' || user.role === 'admin' || user.role === 'union')) && (
                  <Button variant="primary" onClick={() => handleBuy(product)} disabled={product.stock <= 0}>
                    {product.stock > 0 ? '立即兑换' : '已售罄'}
                  </Button>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>确认兑换</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            确认要用 <b>{selectedProduct?.points_required}</b> 积分兑换 <b>{selectedProduct?.name}</b> 吗？
          </div>
          <div className="d-flex align-items-center">
            <span>兑换数量：</span>
            <Button variant="outline-secondary" size="sm" className="mx-2" onClick={() => setQuantity(q => Math.max(1, q - 1))} disabled={quantity <= 1}>-</Button>
            <Form.Control type="number" min={1} max={selectedProduct?.stock || 1} value={quantity} onChange={e => setQuantity(Math.max(1, Math.min(Number(e.target.value), selectedProduct?.stock || 1)))} style={{width:60, display:'inline-block', marginRight:8}} />
            <Button variant="outline-secondary" size="sm" onClick={() => setQuantity(q => Math.min((selectedProduct?.stock || 1), q + 1))} disabled={quantity >= (selectedProduct?.stock || 1)}>+</Button>
            <span className="ms-2">（剩余库存：{selectedProduct?.stock}）</span>
          </div>
          <div className="mt-2 text-muted">总积分：{selectedProduct ? selectedProduct.points_required * quantity : 0}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={handleConfirmBuy}>
            确认兑换
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Shop;
